<template><!-- <?xml version="1.0" encoding="iso-8859-1"?> -->
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 501.334 501.334" style="enable-background:new 0 0 501.334 501.334;" xml:space="preserve">
<g>
	<g>
		<path d="M401.067,98.204l57.6-55.467c8.533-7.467,8.533-20.267,1.067-28.8c-7.467-8.533-20.267-8.533-28.8-1.067l-76.8,73.6
			c-33.067-6.4-69.333-9.6-103.467-9.6c-41.6,0-84.267,4.267-122.667,13.867L62.934,15.004c-7.467-8.533-20.267-9.6-28.8-2.133
			c-8.534,7.466-9.6,20.267-2.133,28.8l53.333,61.867C35.2,122.737,0,150.47,0,187.803V384.07
			c0,71.467,129.067,109.867,250.667,109.867s250.667-38.4,250.667-109.867V186.737c0,0.87,0.001,1.018,0.001,0.469
			c0-0.124,0-0.272,0-0.469C501.334,146.204,459.734,116.337,401.067,98.204z M460.801,384.071
			c0,27.733-82.133,69.333-210.133,69.333S40.534,412.871,40.534,384.071v-134.4c48,30.933,130.133,48,210.133,48
			s162.133-16,210.133-48V384.071z M250.667,257.137c-128,0-210.133-42.667-210.133-70.4c0-16,26.667-36.267,73.6-50.133
			l39.467,45.867c11.733,12.8,24.533,5.333,28.8,2.133c8.533-7.467,9.6-20.267,2.133-28.8l-26.667-30.933
			c26.667-5.333,57.6-7.467,92.8-7.467c24.533,0,46.933,1.067,67.2,4.267l-34.133,33.067c-8.533,7.467-8.533,20.267-1.067,28.8
			c13.867,12.8,25.6,4.267,28.8,0l55.467-53.333c59.733,14.933,93.867,39.467,93.867,57.6
			C460.801,215.538,378.667,257.137,250.667,257.137z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>